import React from 'react'

const Impressum = () => {
  return (
    <div>
      <div className='bg-aubergine p-8'>
      <h1 className='font-bold text-3xl mb-8'>Fasti - Familienkalender</h1>       
      <h2 className='font-bold text-lg'>Impressum</h2>

      <p className='pt-8'>
        Hannes Müller-Stucki<br/>
        Hobrechtstr. 58<br/>
        12047 Berlin<br/>
        Deutschland<br/>
        E-Mail: mailer@stucki.cc
      </p>
      <p className='py-8'>
        Verantwortlich gemäß §18 MStV:<br/>
        Hannes Müller-Stucki<br/>
        Hobrechtstr. 58<br/>
        12047 Berlin<br/>
      </p>
    </div>
    </div>
  )
}

export default Impressum